import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import OpenChat from "./OpenChat";
import ClosedChat from "./ClosedChat";
import UnreadChat from "./UnreadChat";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <>{children}</>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const StatusTabs = ({ onClickItem }) => {
  //Tab Logic
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="bg-white">
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            centered
            className="!text-xs"
          >
            <Tab label="Open" className="!text-xs !normal-case !font-bold " {...a11yProps(0)} />
            <Tab label="Closed" className="!text-xs !normal-case !font-bold " {...a11yProps(1)} />
            <Tab label="Unread" className="!text-xs !normal-case !font-bold " {...a11yProps(2)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <OpenChat onClickItem={onClickItem} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ClosedChat onClickItem={onClickItem} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <UnreadChat onClickItem={onClickItem} />
        </TabPanel>
      </Box>
    </div>
  );
};

export default StatusTabs;
